import React from 'react';
import './style.css';
import { useNavigate } from 'react-router-dom';

interface ItemListProps extends React.HTMLAttributes<HTMLDivElement> {
    link?: string;
    bigPaddingHorizontalNotification?: boolean;
    className?: string;
    idItem?: string;
    children?: React.ReactNode;
}

const ItemList: React.FC<ItemListProps> = ({ link, children, className, idItem, bigPaddingHorizontalNotification, ...rest }) => {
    const navigate = useNavigate();

    const handleNavigate = () =>{  
        if(link){
            return navigate(link)
        }
    }
    return (
        <>
        {/* notification_opened */}
            {/* <div  onClick={handleNavigate} className={`${classItem} ${bigPaddingHorizontalNotification ? "big-padding-horizontal-notification" : ""}  user-select-none row-item-list`} id={`${idItem}`} style={{cursor: link ? "pointer" : "default"}}>
                <div className="col" style={{maxWidth: "100%"}}>
                    <p className="tetx-config">
                        {children}
                    </p>
                </div>
            </div> */}

            <div {...rest} className={`${className} row-notification open-notification row-user row-item-list`}>
                <span onClick={handleNavigate} className="name-likes" style={{ paddingLeft: 0 }}>
                   {children}
                </span>
            </div>
        </>
    );
};

export default ItemList;
